<myp-segmented-bar [white]="true" (selected)="selectSection($event.id)" [options]="sections"></myp-segmented-bar>

@if (selectedSection == "list") {
  <div class="m-t-20">
    <div class="d-flex">
      <div class="form-group m-r-10">
        <label class="t-12 text-muted mb-0" for="sku">Search By</label>
        <select class="form-control custom-select-sm" [(ngModel)]="queryType" id="queryType">
          <option value="sku">SKU</option>
          <option value="serial">Serial Number</option>
        </select>
      </div>
      <div class="form-group">
        <label class="t-12 text-muted mb-0" for="sku">Search Value</label>
        <div class="d-flex align-items-center">
          <input
            class="form-control m-r-5"
            name="sku"
            id="sku"
            [placeholder]="queryType == 'sku' ? 'Enter sku...' : 'Enter a serial number...'"
            [(ngModel)]="queryValue"
            (keyup.enter)="searchFenderGear()"
          />
          <button class="btn btn-primary" type="button" (click)="searchFenderGear()">
            <fa-icon [icon]="searching ? 'spinner' : 'search'" [animation]="searching ? 'spin' : ''"></fa-icon>
          </button>
        </div>
      </div>
    </div>

    @if (fenderGear) {
      <div class="d-flex align-items-end">
        <img [src]="fenderGear.product.imageUrl" style="width: 50px" />
        <div class="m-l-10">
          <span class="fui-heading-font t-30">{{ title || fenderGear.product.title }}</span>
          @if (subTitle) {
            <div class="text-muted t-14">{{ subTitle }}</div>
          }
        </div>
      </div>
      <hr />
      <button class="btn btn-sm btn-secondary" [disabled]="regeneratingSnapshot" (click)="regenerateSnapshot()">
        @if (regeneratingSnapshot) {
          <fa-icon icon="spinner" animation="spin"></fa-icon>
          Regenerating...
        } @else {
          Regenerate Snapshot
        }
      </button>
      <hr />
      <div class="text-muted" [innerHTML]="fenderGear.product.description | safe: 'html'"></div>

      @if (fenderGear.fenderProductSpecs) {
        <div class="m-t-20">
          <h4 class="section-header m-b-10 m-t-30">
            {{ "productDetail.specs" | translate }}
            <span class="section-header-link" (click)="specsCollapsed = !specsCollapsed">
              {{ specsCollapsed ? ("sphere.expand" | translate) : ("sphere.collapse" | translate) }}
              <fa-icon [icon]="specsCollapsed ? 'chevron-down' : 'chevron-up'"></fa-icon>
            </span>
          </h4>
          @if (!specsCollapsed) {
            <div class="specs-container" [ngStyle]="{ 'max-height': showAllSpecs ? 'none' : '565px' }">
              @for (spec of allSpecs; track spec) {
                <div class="m-b-20">
                  <span class="t-16 brandfont-bold">
                    {{ ("productDetail.specSections." + spec.Name | translate) === "productDetail.specSections." + spec.Name ? spec.Name : ("productDetail.specSections." + spec.Name | translate) }}
                  </span>
                  <div class="guitar-specs-table">
                    @for (item of spec | keyvalue; track item) {
                      @if (item.key != "Name") {
                        <div class="spec-row">
                          <span class="spec-key">
                            {{ ("productDetail.specFields." + item.key | translate) === "productDetail.specFields." + item.key ? item.key : ("productDetail.specFields." + item.key | translate) }}:
                          </span>
                          <span class="spec-value">{{ item.value }}</span>
                        </div>
                      }
                    }
                  </div>
                </div>
              }
            </div>
            <button class="brand-btn-reverse sm m-t-20" (click)="showAllSpecs = !showAllSpecs">
              {{ "productDetail.show" | translate }} {{ showAllSpecs ? ("productDetail.less" | translate) : ("productDetail.more" | translate) }}
            </button>
          }
        </div>
      }
    }

    @if (snapshotError) {
      <div class="m-t-20">
        A snapshot could not be created for this product for the following reason:
        <div class="alert alert-danger">
          <code>
            {{ snapshotError }}
          </code>
        </div>
      </div>
    }

    @if (dataSources?.length) {
      <div class="m-t-20">
        <h4 class="section-header m-b-10 m-t-30">
          Data Sources
          <span class="section-header-link" (click)="dataSourcesCollapsed = !dataSourcesCollapsed">
            {{ dataSourcesCollapsed ? ("sphere.expand" | translate) : ("sphere.collapse" | translate) }}
            <fa-icon [icon]="dataSourcesCollapsed ? 'chevron-down' : 'chevron-up'"></fa-icon>
          </span>
        </h4>

        @if (!dataSourcesCollapsed) {
          @for (dataSource of dataSources; track dataSource) {
            <div class="m-b-20">
              <span class="d-block fui-heading-font t-20" [class.c-red]="dataSource.error">{{ dataSource.source }}</span>
              <span class="d-block t-16">API: {{ dataSource.api }}</span>
              <span class="d-block t-16">Endpoint: {{ dataSource.endpoint }}</span>
              <div>
                @if (dataSource.data) {
                  <pre style="background: #1e1e1e; color: #d4d4d4; padding: 16px; border-radius: 8px; overflow: auto; max-height: 400px">
<code>
{{ dataSource.data | json }}
</code>
                  </pre>
                } @else if (dataSource.error) {
                  <div style="background: #1e1e1e; color: #d4d4d4; padding: 16px; border-radius: 8px; overflow: auto; max-height: 400px">
                    <code>Error: {{ dataSource.error }}</code>
                  </div>
                }
              </div>
            </div>
          }
        }
      </div>
    }
  </div>
}
@if (selectedSection == "missing_serials") {
  <div class="m-t-20">
    <div class="d-flex flex-wrap m-b-20 align-items-center learn-content-filters" id="filter_options">
      <div class="form-group m-r-10">
        <label class="t-12 text-muted mb-0" for="migrated">Legacy Migrated Gear</label>
        <select class="form-control custom-select-sm" (change)="filter()" [(ngModel)]="filters.migrated" id="migrated">
          <option value="any">Show All</option>
          <option value="yes">Show Migrated</option>
          <option value="no">Hide Migrated</option>
        </select>
      </div>
      <div class="form-group m-r-10">
        <label class="t-12 text-muted mb-0" for="sku">Sku</label>
        <select class="form-control custom-select-sm" (change)="filter()" [(ngModel)]="filters.sku" id="sku">
          <option value="any">Show All</option>
          <option value="yes">Show With SKU</option>
          <option value="no">Show Without SKU</option>
        </select>
      </div>
      <div class="form-group m-r-10">
        <label class="t-12 text-muted mb-0" for="sku">Limit</label>
        <select class="form-control custom-select-sm" (change)="loadMissingSerials(null, true)" [(ngModel)]="pageLimit" id="limit">
          <option value="20">20</option>
          <option value="50">50</option>
          <option value="100">100</option>
          <option value="500">500</option>
          <option value="1000">1000</option>
          <option value="2000">2000</option>
        </select>
      </div>
      <div class="m-r-10">or</div>
      <div class="d-flex">
        <div class="form-group m-r-10">
          <label class="t-12 text-muted mb-0" for="sku">Search By</label>
          <select class="form-control custom-select-sm" [(ngModel)]="queryType" id="queryType">
            <option value="email">Email</option>
            <option value="userId">User ID</option>
          </select>
        </div>
        <div class="form-group">
          <label class="t-12 text-muted mb-0" for="sku">Search Value</label>
          <div class="d-flex align-items-center">
            <input class="form-control m-r-5" name="sku" id="sku" [placeholder]="queryType == 'email' ? 'Enter email...' : 'Enter a user ID...'" [(ngModel)]="queryValue" (keyup.enter)="search()" />
            <button class="btn btn-primary" type="button" (click)="search()">
              <fa-icon [icon]="searching ? 'spinner' : 'search'" [animation]="searching ? 'spin' : ''"></fa-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
    @if (!loading && displayedMissingSerials?.length < missingSerials?.length) {
      <div class="m-y-20">Showing {{ displayedMissingSerials?.length }} of {{ missingSerials?.length }} on this page.</div>
    }
    <myp-inline-loader [loading]="loading" height="400px" spinnerName="loading"></myp-inline-loader>
    @for (ms of displayedMissingSerials; track ms) {
      <myp-list-item
        [photo]="ms.snapshot ? ms.snapshot.product.imageUrl : ms.bodyImageUrl ? ms.bodyImageUrl : './assets/images/default_avatar.jpg'"
        [showImage]="ms.snapshot?.product?.imageUrl || ms.bodyImageUrl"
        [title]="ms.snapshot ? ms.snapshot.product.title : ms.productName"
        [imageRound]="false"
        [collapsible]="true"
        [includeChevron]="false"
        [showBackground]="true"
        [metadata]="[
          { title: 'Date Added', value: ms.created ? (ms.created | date) : 'Unknown' },
          { title: 'Serial Number', value: ms.serial },
          { title: 'SKU', value: ms.sku || 'No SKU entered.', valueColor: ms.sku ? 'green' : 'red' },
          { title: 'User ID', value: ms.userId },
        ]"
        [marginBottom]="'10px'"
      >
        <div class="collapsible-content">
          <div class="row">
            <div class="col-12 m-b-20">
              <div class="text-muted t-12">Name</div>
              <div class="font-weight-bold">
                {{ ms.snapshot?.product?.title || ms.productName || "No name entered." }}
              </div>
            </div>
            <div class="col-12 m-b-20">
              <div class="text-muted t-12">Serial Number</div>
              <div class="font-weight-bold">
                {{ ms.serial }}
              </div>
            </div>
            <div class="col-lg-3 col-md-4 col-6 m-b-20">
              <div class="text-muted t-12">Sku</div>
              <div class="font-weight-bold">
                @if (!ms.showingEnterSku) {
                  {{ ms.sku || "No SKU entered." }}
                  @if (!ms.sku) {
                    <button class="small-btn m-l-10" (click)="ms.showingEnterSku = true">Enter SKU</button>
                  }
                }
                @if (ms.showingEnterSku) {
                  <input type="text" class="form-control" [(ngModel)]="ms.sku" (keyup.enter)="saveSku(ms)" />
                  <button class="btn btn-primary btn-sm m-t-10" type="button" (click)="saveSku(ms)" [disabled]="savingSku">
                    @if (savingSku) {
                      <fa-icon icon="spinner" animation="spin"></fa-icon>
                    }
                    {{ savingSku ? "Saving..." : "Save" }}
                  </button>
                  <button class="btn btn-blank btn-sm m-t-10" type="button" (click)="ms.sku = undefined; ms.showingEnterSku = false">Cancel</button>
                }
              </div>
            </div>
            <div class="col-lg-3 col-md-4 col-6 m-b-20">
              <div class="text-muted t-12">User ID</div>
              <div class="font-weight-bold">
                <a [routerLink]="['/customer/detail/', ms.userId]">{{ ms.userId }}</a>
              </div>
            </div>
            @if (ms.shopLink) {
              <div class="col-lg-3 col-md-4 col-6 m-b-20">
                <div class="text-muted t-12">Shop Link</div>
                <div class="font-weight-bold">
                  <a [href]="ms.shopLink" target="_blank">Visit Link</a>
                </div>
              </div>
            }
          </div>
          @if (ms.bodyImageUrl) {
            <div class="row">
              <div class="col-lg-3 col-md-4 col-12 m-b-20">
                <div class="text-muted t-12">Gear Body</div>
                <img [src]="ms.bodyImageUrl" (click)="showImage(ms.bodyImageUrl)" class="img-thumbnail w-full" />
              </div>
              <div class="col-lg-3 col-md-4 col-12 m-b-20">
                <div class="text-muted t-12">Serial Number Photo</div>
                <img [src]="ms.serialImageUrl" (click)="showImage(ms.serialImageUrl)" class="img-thumbnail w-full" />
              </div>
            </div>
          }
          <div class="row">
            <div class="col-12">
              <span class="small-btn red" (click)="deleteMissingSerial(ms)">{{ "product_detail.deregister" | translate }}</span>
            </div>
          </div>
        </div>
      </myp-list-item>
    }
    @if (!loading && missingSerials?.length) {
      <myp-paginator
        [offset]="pageOffset"
        [limit]="pageLimit"
        [resultsLength]="missingSerials.length"
        [paginate]="paginate"
        [async]="false"
        [loadingNext]="loadingNext"
        [loadingPrevious]="loadingPrevious"
        [hasNext]="!!nextToken"
      ></myp-paginator>
    }
  </div>
}
